// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"6a36c953","111":"4c8d22a8","122":"63fc30bb","134":"d91c6a06","531":"917f32fc","570":"1095c3f1","713":"8eccce5b","759":"988404ad"}[chunkId] + ".chunk.css";
};